import React, { lazy, Suspense } from 'react';

const LazyDealerResourcesPage = lazy(() => import('./DealerResourcesPage'));

const DealerResourcesPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyDealerResourcesPage {...props} />
  </Suspense>
);

export default DealerResourcesPage;
